module.exports = __webpack_public_path__ + "img/boundary-escalation-event.78edf607.svg";